import React, { useState } from 'react';
import * as S from './style';
import { Chat, Close, Send } from '@mui/icons-material';

const ChatBot = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [messages, setMessages] = useState([
        {
            id: 1,
            text: '안녕하세요! 무엇을 도와드릴까요?',
            isBot: true,
            timestamp: new Date(),
        },
    ]);
    const [inputText, setInputText] = useState('');

    // 봇 응답 메시지 배열
    const botResponses = [
        '죄송합니다. 현재 개발 중인 기능입니다. 곧 더 나은 서비스를 제공하겠습니다!',
        '흥미로운 질문이네요! 소다맵에서 더 자세한 정보를 확인해보세요.',
        '좋은 질문입니다. 소다맵의 갤러리에서 관련 데이터를 찾아보실 수 있어요.',
        '현재 이 기능은 준비 중입니다. 조금만 기다려주세요!',
        '소다맵의 지도 기능을 활용해보시는 건 어떨까요?',
        '더 자세한 정보가 필요하시면 소다맵의 다양한 카테고리를 살펴보세요.',
        '이 질문에 대한 답변을 준비하고 있습니다. 곧 업데이트될 예정입니다!',
        '소다맵에서 제공하는 통계 데이터를 참고해보시면 도움이 될 것 같아요.',
        '현재 시스템 점검 중입니다. 잠시 후 다시 시도해주세요.',
        '소다맵의 지역별 데이터를 확인해보시는 것을 추천드립니다.',
    ];

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleSendMessage = () => {
        if (inputText.trim()) {
            const newMessage = {
                id: messages.length + 1,
                text: inputText,
                isBot: false,
                timestamp: new Date(),
            };
            setMessages([...messages, newMessage]);
            setInputText('');

            // 봇 응답 시뮬레이션
            setTimeout(() => {
                const randomIndex = Math.floor(Math.random() * botResponses.length);
                const botResponse = {
                    id: messages.length + 2,
                    text: botResponses[randomIndex],
                    isBot: true,
                    timestamp: new Date(),
                };
                setMessages((prev) => [...prev, botResponse]);
            }, 1000);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSendMessage();
        }
    };

    return (
        <S.ChatBotContainer>
            {/* 채팅창 */}
            {isOpen && (
                <S.ChatWindow>
                    <S.ChatHeader>
                        <S.ChatTitle>소다맵 챗봇</S.ChatTitle>
                        <S.CloseButton onClick={handleToggle}>
                            <Close />
                        </S.CloseButton>
                    </S.ChatHeader>

                    <S.ChatMessages>
                        {messages.map((message) => (
                            <S.MessageContainer key={message.id} isBot={message.isBot}>
                                <S.MessageBubble isBot={message.isBot}>{message.text}</S.MessageBubble>
                                {!message.isBot && (
                                    <S.MessageTime>
                                        {message.timestamp.toLocaleTimeString('ko-KR', {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                        })}
                                    </S.MessageTime>
                                )}
                            </S.MessageContainer>
                        ))}
                    </S.ChatMessages>

                    <S.ChatInputContainer>
                        <S.ChatInput
                            type="text"
                            placeholder="메시지를 입력하세요..."
                            value={inputText}
                            onChange={(e) => setInputText(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        <S.SendButton onClick={handleSendMessage}>
                            <Send />
                        </S.SendButton>
                    </S.ChatInputContainer>
                </S.ChatWindow>
            )}

            {/* Floating 버튼 */}
            <S.FloatingButton onClick={handleToggle} isOpen={isOpen}>
                {isOpen ? <Close /> : <Chat />}
            </S.FloatingButton>
        </S.ChatBotContainer>
    );
};

export default ChatBot;
